import {
  CustomScreenNames,
} from 'mobx-store/stores/customScreens/types';

const customScreensPath = '/custom-screens';

export const getCustomScreen = (screenName: string) => `${customScreensPath}/${screenName}`;
export const getCustomScreens = `${customScreensPath}`;
export const createCustomScreens =  `${customScreensPath}`;
export const updateCustomScreens = `${customScreensPath}`;
export const getWidgets = '/widgets';

